import React, { Fragment, useState, useEffect } from "react";
import { Row, Col, Form, Button,Toast } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { IoIosClose, IoMdDownload } from "react-icons/io";
import ReactTable from "../../../components/FilterTable";
import { _HttpServices } from "../../../_services/_HttpServices";
import Loader from "../../../components/Loader";
// import Loader from "../../components/Loader";
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import moment from 'moment'
import { useHistory } from 'react-router';
import getExcel from "../../../_services/ExcelUtility";
import { Footer } from "../../../components/Footer";

const OutboundInventoryPage = () =>{
    const fileName = 'Inventory Source Data';
    const outbounddata = JSON.parse(localStorage.getItem("outboundreport"));
    const history = useHistory();
    const [inventory, setInventory] = useState([]);
    const [loading, setLoading] = useState(false);
    // const [showToaster, setShowToaster] = useState(false);
    // let Message;
    const [hasError, setHasError] = useState(false);
    const columns = [
        
        {
            Header: "Assigned_Customer_Key",
            accessor: "Assigned_Customer_Key",
            filter: "Assigned_Customer_Key",
            sortType: "basic",
            width:200,
        },
        {
            Header: "Dc_ID_Key",
            accessor: "Dc_ID_Key",
            filter: "Dc_ID_Key",
            sortType: "basic",
            width:120,
        },
        {
            Header: "Dc_ID_Qual",
            accessor: "Dc_ID_Qual",
            filter: "Dc_ID_Qual",
            sortType: "basic",
            width:115,
        }, {
            Header: "NdcUpc",
            accessor: "NDC",
            filter: "NDC",
            sortType: "basic",
            width:120,
        }, {
            Header: "NdcUpc_Qual",
            accessor: "NdcUpc_Qual",
            filter: "NdcUpc_Qual",
            sortType: "basic",
            width:120,
        },
        {
            Header: "ReportingDate",
            accessor: "ReportingDate",
            filter: "ReportingDate",
            sortType: "basic",
            width:120,
            filterMethod: (filter, row) => {
                const rowValue = row.original
                return rowValue.datefiled.includes(filter.value)
            }
        },
        {
            Header: "UOM",
            accessor: "UOM",
            filter: "UOM",
            sortType: "basic",
            width:100,
        },
        // ==================
        {
            Header: "AM",
            accessor: "AM",
            // disableFilters: true,
            // disableSortBy: true,
        },
        {
            Header: "BS",
            accessor: "BS",
            // disableFilters: true,
            // disableSortBy: true,
        },
        {
            Header: "BT",
            accessor: "BT",
            // disableFilters: true,
            // disableSortBy: true,
        },
        {
            Header: "DD",
            accessor: "DD",
            // disableFilters: true,
            // disableSortBy: true,
        },
        {
            Header: "DS",
            accessor: "DS",
            // disableFilters: true,
            // disableSortBy: true,
        },
        {
            Header: "HL",
            accessor: "HL",
            // disableFilters: true,
            // disableSortBy: true,
        },
        {
            Header: "IT",
            accessor: "IT",
            // disableFilters: true,
            // disableSortBy: true,
        },
        {
            Header: "LF",
            accessor: "LF",
            // disableFilters: true,
            // disableSortBy: true,
        },
        {
            Header: "LO",
            accessor: "LO",
            // disableFilters: true,
            // disableSortBy: true,
        },
        {
            Header: "LS",
            accessor: "LS",
            // disableFilters: true,
            // disableSortBy: true,
        },
        {
            Header: "MS",
            accessor: "MS",
            // disableFilters: true,
            // disableSortBy: true,
        },
        {
            Header: "OF",
            accessor: "OF",
            // disableFilters: true,
            // disableSortBy: true,
        },
        {
            Header: "OP",
            accessor: "OP",
            // disableFilters: true,
            // disableSortBy: true,
        },
        {
            Header: "OQ",
            accessor: "OQ",
            // disableFilters: true,
            // disableSortBy: true,
        },
        {
            Header: "PA",
            accessor: "PA",
            // disableFilters: true,
            // disableSortBy: true,
        },
        {
            Header: "PO",
            accessor: "PO",
            // disableFilters: true,
            // disableSortBy: true,
        },
        {
            Header: "Q1",
            accessor: "Q1",
            // disableFilters: true,
            // disableSortBy: true,
        },
        {
            Header: "Q2",
            accessor: "Q2",
            // disableFilters: true,
            // disableSortBy: true,
        },
        {
            Header: "Q3",
            accessor: "Q3",
            // disableFilters: true,
            // disableSortBy: true,
        },
        {
            Header: "Q4",
            accessor: "Q4",
            // disableFilters: true,
            // disableSortBy: true,
        },
        // ==============
        {
            Header: "QA",
            accessor: "AvailableQuantity",
            filter: "AvailableQuantity",
            sortType: "basic",
            width:80,
        },
        // ==================
        {
            Header: "QB",
            accessor: "QB",
            // disableFilters: true,
            // disableSortBy: true,
        },
        {
            Header: "QC",
            accessor: "QC",
            // disableFilters: true,
            // disableSortBy: true,
        },
        {
            Header: "QD",
            accessor: "QD",
            // disableFilters: true,
            // disableSortBy: true,
        },
        {
            Header: "QE",
            accessor: "QE",
            // disableFilters: true,
            // disableSortBy: true,
        },
        {
            Header: "QF",
            accessor: "QF",
            // disableFilters: true,
            // disableSortBy: true,
        },
        {
            Header: "QH",
            accessor: "QH",
            // disableFilters: true,
            // disableSortBy: true,
        },
        {
            Header: "QI",
            accessor: "QI",
            // disableFilters: true,
            // disableSortBy: true,
        },
        {
            Header: "QK",
            accessor: "QK",
            // disableFilters: true,
            // disableSortBy: true,
        },
        {
            Header: "QL",
            accessor: "QL",
            // disableFilters: true,
            // disableSortBy: true,
        },
        {
            Header: "QM",
            accessor: "QM",
            // disableFilters: true,
            // disableSortBy: true,
        },
        {
            Header: "QN",
            accessor: "QN",
            // disableFilters: true,
            // disableSortBy: true,
        },
        {
            Header: "QO",
            accessor: "QO",
            // disableFilters: true,
            // disableSortBy: true,
        },
       
        // ==================
        {
            Header: "QP",
            accessor: "QP",
            filter: "QP",
            sortType: "basic",
            width:80,
        },
        {
            Header: "QR",
            accessor: "QR",
            filter: "QR",
            sortType: "basic",
            width:80,
        },
        {
            Header: "QS",
            accessor: "QS",
            filter: "QS",
            sortType: "basic",
            width:80,
        },
         // ==================
         {
            Header: "QT",
            accessor: "QT",
            // disableFilters: true,
            // disableSortBy: true,
        },
        {
            Header: "QU",
            accessor: "QU",
            // disableFilters: true,
            // disableSortBy: true,
        },
        {
            Header: "QW",
            accessor: "QW",
            // disableFilters: true,
            // disableSortBy: true,
        },
        {
            Header: "QX",
            accessor: "QX",
            // disableFilters: true,
            // disableSortBy: true,
        },
        {
            Header: "QZ",
            accessor: "QZ",
            // disableFilters: true,
            // disableSortBy: true,
        },
        {
            Header: "RE",
            accessor: "RE",
            // disableFilters: true,
            // disableSortBy: true,
        },
        {
            Header: "TC",
            accessor: "TC",
            // disableFilters: true,
            // disableSortBy: true,
        },
        {
            Header: "TM",
            accessor: "TM",
            // disableFilters: true,
            // disableSortBy: true,
        },
        {
            Header: "TS",
            accessor: "TS",
            // disableFilters: true,
            // disableSortBy: true,
        },
        {
            Header: "WQ",
            accessor: "WQ",
            // disableFilters: true,
            // disableSortBy: true,
        },
        {
            Header: "WS",
            accessor: "WS",
            // disableFilters: true,
            // disableSortBy: true,
        },
        {
            Header: "ZZ",
            accessor: "ZZ",
            // disableFilters: true,
            // disableSortBy: true,
        },
        
    
    ];

    useEffect(() => {
        getInventory();
    }, [])
    async function getInventory() {
        setLoading(true);
        await _HttpServices
        .getData(`Api/Inbound/OutboundReportsData?FileProcessID=${outbounddata.FileProcessID}&ServiceTaskID=${outbounddata.ServiceTaskID}&FileTypeCode=${outbounddata.FileTypeCode}&TaskTypeCode=${outbounddata.TaskTypeCode}`)
            // .getData(`api/inbound/OutBoundInventory?fileprocessId=${outbounddata.File_Process_ID}`)
            .then((data) => {
                let inventoryResult = data.data;
                if(inventoryResult.length > 0){
                    inventoryResult.map((res) => { 
                        // res.ReportingDate = moment(res.ReportingDate).format('YYYYMMDD')
                        res.ReportingDate = moment(res.ReportingDate).format('YYYY/MM/DD')
                        res.AM=0; res.BS=0;res.BT=0;res.DD=0;res.DS=0;res.HL=0;res.IT=0;res.LF=0;res.LO=0;res.LS=0;res.MS=0;res.OF=0;res.OP=0;res.OQ=0;res.PA=0;res.PO=0;res.Q1=0;res.Q2=0;res.Q3=0;res.Q4=0
                        res.QB=0;res.QC=0;res.QD=0;res.QE=0;res.QF=0;res.QH=0;res.QI=0;res.QK=0;res.QL=0;res.QM=0;res.QN=0;res.QO=0;res.QT=0;res.QU=0;res.QW=0;res.QX=0;res.QZ=0;res.RE=0;res.TC=0;res.TM=0;res.TS=0;res.WQ=0;res.WS=0;res.ZZ=0;
                    })
                }
                setInventory(inventoryResult);
                setLoading(false);
            })
            .catch((e) => {
                setLoading(false);
                // Message = e.response.data.Message;
                // setShowToaster(true);
                setHasError(true);
            });
    }
    const EditRecords = () =>{
        localStorage.setItem("inventory",JSON.stringify(inventory));
        history.push("/GenentechInventoryEdit")
    }
    return (
        <section className="content">
            <div className="page-title">
                <h2 className="h2">Inventory Source Data</h2>
                {loading ? <Loader /> : null}
                <div>
                {inventory.length > 0 && (outbounddata.FileSentStatus == "Sent" ? <Button type="submit" onClick={() =>EditRecords()}>Create Reversal</Button> :
                    <Button type="submit" onClick={() =>EditRecords()}>Edit Records</Button>
                    )}
                <Button type="submit" className="ml-2" onClick={() => getExcel(columns,inventory,fileName)}><IoMdDownload className="icon btn-icon" />Download Excel </Button>
                </div>
            </div>
              {/* Toaster */}
              {/* <Toast onClose={() => setShowToaster(false)} show={showToaster} delay={1500} autohide className="custom-toaster">
                <Toast.Header>
                    <img
                        src="holder.js/20x20?text=%20"
                        className="rounded mr-2"
                        alt=""
                    />
                    <strong className="mr-auto">Woohoo!!</strong>
                </Toast.Header>
                
                <Toast.Body>{Message}</Toast.Body>
            </Toast> */}
            <Row>
                <Col md={12}>
                    <div className="card pt-2">
                        <div className="card-body">
                            <div className="inventory-grid">
                            {hasError ? <p>Error occurred. Unable to load Inventory Source Data.</p> :
                                <Fragment>
                                    {inventory.length > 0 ? (
                                        <ReactTable columns={columns} data={inventory} defaultPageSize={10} />
                                    ) : (
                                            <div className="no-data">No data found.</div>
                                        )}
                                </Fragment>
                            }
                            </div>
                        </div>
                    </div>
                </Col>
            </Row>
            <Row>
              <Col md={12} className="text-right mt-2">
                <Button
                  variant="danger"
                  type="button"
                  className="ml-3"
                   onClick={() => history.goBack()}
                >
                  <IoIosClose className="icon btn-icon" />
                  Cancel
                </Button>
              </Col>
            </Row>
            <Footer />
        </section>
    );
}

export default OutboundInventoryPage;